import type { ReactNode } from "react";
import { DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ClosableDialogTitleProps {
  children: ReactNode;
  /** Called when the top-right X is clicked. */
  onClose: () => void;
  /** Disable the close button (e.g. while a mutation is in flight). */
  disabled?: boolean;
}

/**
 * Standard dialog header with a title and a top-right close (X) button, so users
 * can dismiss any popup without scrolling to the bottom Cancel action.
 * Use in place of a bare <DialogTitle> across all modals.
 */
export function ClosableDialogTitle({ children, onClose, disabled }: ClosableDialogTitleProps) {
  return (
    <DialogTitle sx={{ pr: 6 }}>
      {children}
      <IconButton
        aria-label="close"
        onClick={onClose}
        disabled={disabled}
        size="small"
        sx={{ position: "absolute", right: 8, top: 8, color: (t) => t.palette.grey[500] }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
  );
}
